module.exports = __webpack_public_path__ + "static/media/32.390a8755.png";